<div class="page" *ngIf="template == 1">
    <div class="page-body" *ngIf="response.status == 1">
        <div class="page-content">
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <section class="section-form" *ngIf="!isMobile">
                            <div class="categorias">
                                <div class="item" [ngClass]="{'active': categoriaId == c.id}" *ngFor="let c of categorias" (click)="selectCategoria(c)">
                                    <div class="icon">
                                        <img [src]="c.icone" [title]="c.nome" width="30px" />
                                    </div>
                                    <div class="text">
                                        <span>{{c.nome}}</span>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="section-form-mobile" *ngIf="isMobile">
                            <div class="wp-layout-grid">
                                <div class="item wp-layout-item" [ngClass]="{'active': categoriaId == c.id}" *ngFor="let c of categorias" (click)="selectCategoria(c)">
                                    <div class="icon">
                                        <img [src]="c.icone" [title]="c.nome" width="30px" />
                                    </div>
                                    <div class="text">
                                        <span>{{c.nome}}</span>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="col-md-9">
                        <negocios-list [changeCategoria]="changeCategoria"></negocios-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="page-body" *ngIf="response.status == 500">
        <page-error (reload)="getData()"></page-error>   
    </div>    
</div>  
<div class="page" *ngIf="template == 2">
    <div class="page-title">
        <div class="container">
            <h2 class="title-custom">Cadastro Empresarial</h2>
        </div>
    </div>
    <div class="page-body">
        <div class="page-content">
            <div class="container">
                <form class="section-form-store form form-custom" *ngIf="formTemplate == 1">
                    <h3>Dados Pessoais</h3>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Nome Completo:</label>
                            <input type="text" [(ngModel)]="dataItem.nome" name="nome" placeholder="Informe se nome completo"/>
                        </div>
                    </div>  
                    <div class="row">
                        <div class="col-md-12">
                            <label>Telefone / WhatsApp:</label>
                            <input type="text" [(ngModel)]="dataItem.telefone" name="telefone" mask="(99) 99999-9999" placeholder="(**) *****-****" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Ano que você se tornou membro da Greenhouse:</label>
                            <input label="Informe o Ano:" type="text" [(ngModel)]="dataItem.membro_ano" name="membro_ano" placeholder="Ex: 2023" />
                        </div>
                    </div>  
                    <h3>Dados da sua Empresa</h3>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Nome da Empresa:</label>
                            <input type="text" [(ngModel)]="dataItem.empresa_nome" name="empresa_nome" placeholder="Informe o nome da sua empresa / negócio"/>
                        </div>
                    </div> 
                    <div class="row">
                        <div class="col-md-12">
                            <label>Telefone Comercial:</label>
                            <input type="text" [(ngModel)]="dataItem.empresa_telefone" name="empresa_telefone" mask="(99) 99999-9999" placeholder="(**) *****-****" />
                        </div>
                    </div> 
                    <div class="row">
                        <div class="col-md-12">
                            <label>Área de Atuação:</label>
                            <input type="text" [(ngModel)]="dataItem.empresa_atuacao" name="empresa_atuacao" placeholder="Exemplo: Sáude, Venda de Produtos, Desenvovimento de Sistemas..." />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Descrição da Empresa:</label>
                            <textarea type="text" [(ngModel)]="dataItem.texto" name="texto" rows="5" placeholder="Escreva sobre a sua empresa."></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Descrição dos seus Serviços:</label>
                            <textarea type="text" [(ngModel)]="dataItem.empresa_servicos" name="empresa_servicos" rows="5" placeholder="Escreva sobre os seus serviços ou produtos."></textarea>
                        </div>
                    </div>  
                    <h3>Redes Sociais</h3>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Link do Facebook (Se tiver):</label>
                            <input type="text" [(ngModel)]="dataItem.link_facebook" name="link_facebook" placeholder="Informe o Link do Facebook do seu Negócio." />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Link do Instagram (Se tiver):</label>
                            <input type="text" [(ngModel)]="dataItem.link_instagram" name="link_instagram" placeholder="Informe o Link do Instagram do seu Negócio." />
                        </div>
                    </div> 
                    <div class="row">
                        <div class="col-md-12">
                            <label>Link do Site (Se tiver):</label>
                            <input type="text" [(ngModel)]="dataItem.link_site" name="link_site" placeholder="Informe o Link do seu Site." />
                        </div>
                    </div>
                    <h3>Endereço</h3>
                    <div class="row">
                        <div class="col-md-12">
                            <label>Endereço Completo:</label>
                            <input type="text" [(ngModel)]="dataItem.empresa_endereco" name="empresa_endereco" placeholder="Informeo endereço completo do seu negóco." />
                        </div>
                    </div>
                    <h3>Foto</h3>
                    <h4 class="title-custom">
                        Escolha uma foto que representa o seu negócio.
                    </h4>
                    <div class="row">
                        <div class="col-md-12"> 
                            <input type="file" [(ngModel)]="foto" name="foto" (change)="_file($event)" />
                        </div>
                    </div>
                    <div class="row" *ngIf="foto != null">
                        <div class="col-md-12"> 
                            <figure>
                                <img src="" alt="Foto" width="100%" id="foto" />
                            </figure>
                        </div>
                    </div>
                    <div class="content-observacao">
                        <h3>Observação</h3>
                        <div class="row">
                            <div class="col-md-12"> 
                                <textarea placeholder="Se você tiver alguma observação escreva aqui." [(ngModel)]="dataItem.observacao" name="observacao" rows="5"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="content-button">
                        <button type="button" class="btn btn-one" (click)="store()">
                            <div class="icon">  
                                <img src="/images/icons/negocio.svg" width="25px" alt="Negócio" />
                            </div>
                            <span>Cadastrar meu Negócio</span>
                        </button>
                    </div>
                </form>
                <div class="section-form-store success" *ngIf="formTemplate == 2">
                    <div class="icon">  
                        <img src="/images/icons/check.svg" alt="Sucesso" width="90px" />
                    </div>
                    <h3>O seu cadastro foi realizado com sucesso.</h3>
                </div>
            </div>
        </div>
    </div>   
</div>        
<loader [hidden]="!loader" message="Carregando. Aguarde!"></loader> 